//login

export const HeaderLogo = `/images/Bajaj_Logo.png`;
export const FooterLogo = `/images/Bajaj_footer_img.png`;
export const lastLoginIcon = "/images/lastLoginIcon.svg";
export const logoutIcon = "/images/bajaj_logout.svg";
export const carouselImage1 = "/images/Distributorempanellment-latest.png";
export const carouselImage4 = "/images/D.I.T. Banners-03.jpg";
export const carouselImage2 = "/images/bajaj_banner.svg";
export const carouselImage3 = "/images/D.I.T. Banners-02.jpg";

// app-side-bar-active-images
export const dashboardActive = "/images/home_active.svg";
export const investorsActive = "/images/investor_active.svg";
export const newTransactionActive = "/images/new_transact_active.svg";
export const navActive = "/images/nav_active.png";
export const mailBackActive = "/images/mailback_active.png";
export const transactionHistoryActive = "/images/transaction_history_active.svg";
export const ekycActive = "/images/ekyc-white.svg";
export const earningsActive = "/images/earnings_active_ham.svg";
export const supportActive = "/images/customer-service.svg";
export const settingsActive = "/images/Bajaj_settings_fill.svg";
export const nfoActive = "/images/nfo_active.svg"

//app-side-bar-inactive-images

export const dashboardInActive = "/images/home.png";
export const investorsInActive = "/images/investor_home.svg";
export const newTransactionInActive = "/images/new_transaction.svg";
export const navInActive = "/images/nav_home.svg";
export const mailBackInActive = "/images/maiback_home.svg";
export const transactionHistoryInActive =
  "/images/transaction_history.svg";
export const ekycInActive = "/images/ekyc.svg";
export const earningsInActive = "/images/myearnings.svg";
export const supportInActive = "/images/support.png";
export const settingsInactive = "/images/settingsActive.svg";
export const nfoInActive = "/images/nfo.svg"

// dashboard

export const earningsBackground = "/images/bajaj_my_earnings_bg.svg";
export const earningsButton = "/images/bajaj_my_earnings_button.svg";

//support

export const raiseaQuery = "/images/mirae_customer_service.svg";

//mailback investor icons

export const MailBackSoaIcon = "/images/bajaj_newsletter.svg";
export const CASIcon = "/images/bajaj_cas.svg";
export const ELSSIcon = "/images/bajaj_elss.svg";
export const CANIcon = "/images/bajaj_can.svg";
export const CGSIcon = "/images/bajaj_cgs.svg";
export const GASIcon = "/images/bajaj_gas.svg";
export const networthIcon = "/images/bajaj_network.svg";
export const mailbackRightarrow = "/images/bajaj_side_arrow.svg";

//app- settings - review year icon

export const timeIcon = "/images/mirae_noun_time.svg";
